import { render, staticRenderFns } from "./EditSettings.vue?vue&type=template&id=8c0518ec&"
import script from "./EditSettings.vue?vue&type=script&lang=js&"
export * from "./EditSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports